import React from 'react';
import { AoInspectieOverspanningenUnitCode } from '../../../../../common/src/domain/customInspectionTypes/amsterdamOverspanningen/inspectieOverspanningen';
import { CollapsiblePanel, EditPanel, EditPanelCellLabel, EditPanelRow, PanelBody, Tray } from '../../../components/elements';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditAoBasisgegevensUnitAll } from './SurveyEditAoBasisgegevensUnitAll';

export function SurveyEditAoBasisgegevensUnit(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateUnitData,
) {
    if (
        [
            AoInspectieOverspanningenUnitCode.Aansluitkast,
            AoInspectieOverspanningenUnitCode.Armatuur,
            AoInspectieOverspanningenUnitCode.Gevelbevestiging,
            AoInspectieOverspanningenUnitCode.Mastbevestiging,
            AoInspectieOverspanningenUnitCode.Spandraadsysteem,
        ].includes(props.unitCode as AoInspectieOverspanningenUnitCode)
    ) {
        return <SurveyEditAoBasisgegevensUnitAll {...props} />;
    }

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <CollapsiblePanel heading={{ dark: true, text: `${props.unitName} details` }}>
                    <PanelBody isForm={true}>
                        <EditPanelRow>
                            <EditPanelCellLabel
                                rowCount={10}
                                text={`Onbekende unit code "${props.unitCode}", alleen codes "U01" en "U02" zijn toegestaan.`}
                            ></EditPanelCellLabel>
                        </EditPanelRow>
                    </PanelBody>
                </CollapsiblePanel>
            </EditPanel>
        </Tray>
    );
}
